import React from "react";

import "./LoginButton.scss";
import { Button } from "@randajan/jet-react/dom/form";
import { Locale } from "../../../assets/Locale";

export const LoginButton = (props)=>{
    const { onClick } = props;
    const say = Locale.use();

    return (
        <Button className="LoginButton" onSubmit={onClick}>{say("userLogin")}</Button>
    );
};
